export const getDefaultValue = (mixin) => mixin({ theme: {} });
//# sourceMappingURL=getDefaultValue.js.map